import { flow, Instance, types } from 'mobx-state-tree'
import { ToastType } from '../../../comps/Toast'
import { agentOnboardingApi } from '../../../network/BillPaymentsService/agentOnboard'
import { checkWhetherTheAgentExistsApi } from '../../../network/BillPaymentsService/agentOnboarding'
import { agentOnboardingApiV3 } from '../../../network/BillPaymentsService/agentOnboardingApiV3'
import { billFetchAPI } from '../../../network/BillPaymentsService/billFetchAPI'
import { checkStatusAPI } from '../../../network/BillPaymentsService/checkStatus'
import { createOrderAPI } from '../../../network/BillPaymentsService/createOrderAPI'
import { fetchUserBC } from '../../../network/BillPaymentsService/Customer/fetchUserBC'
import { genereteOtpBCApi } from '../../../network/BillPaymentsService/Customer/genereteOtpBCApi'
import { registerUserBCApi } from '../../../network/BillPaymentsService/Customer/registerUserBCApi'
import { VerifyOtpBCApi } from '../../../network/BillPaymentsService/Customer/VerifyOtpBCApi'
import { getAuthenticatorList } from '../../../network/BillPaymentsService/getAuthenticatorList'
import { getBrowsePlanListBCApi } from '../../../network/BillPaymentsService/getBrowsePlanList'
import { getCategoryListV2Api } from '../../../network/BillPaymentsService/getCategoryListV2'
import { getCircleListBCApi } from '../../../network/BillPaymentsService/getCircleList'
import { getFavoriteTransactionsBCApi } from '../../../network/BillPaymentsService/getFavoriteTransaction'
import { getLRNMappingBCApi } from '../../../network/BillPaymentsService/getLRNMapping'
import { getOrderHistoryBCApi } from '../../../network/BillPaymentsService/getOrderHistory'
import { getProductListBCApi } from '../../../network/BillPaymentsService/getProductList'
import { manageFavTxnsApi } from '../../../network/BillPaymentsService/manageFavTxns'
// import { createIntentAPI } from '../../../network/BillPaymentsService/payment/createIntentAPI'
import { updatePaymentAPI } from '../../../network/BillPaymentsService/updatePayment'
import { CUSTOMER_VALIDATION_CODES } from '../../../network/DomesticMoneyTransfer/checkWhetherTheCustomerExistsApi'
import { DomesticMoneyTransferStrings } from '../../../screens/DomesticMoneyTransfer/Strings'
import { buildPaymentRedirectUrl } from '../../../screens/MobileRecharge/utility'
import { AESEncrypt, generateRandomString, RSAEncrypt } from '../../../util/utill'
import { RootStore } from '../../store'

const BillerCategory = types.model('BillerCategory', {
  id: types.number,
  name: types.string,
  displayName: types.string,
  status: types.string,
})

const CategoryGroup = types.model('CategoryGroup', {
  categoryType: types.string,
  catetoryList: types.array(BillerCategory),
})

const CATEGORY_ORDER = ['Recharge', 'Finances', 'Utilities', 'Others']

export const CustomerTempData = types
  .model('CustomerTempData', {
    jfsUserId: types.string,
    firstName: types.string,
    middleName: types.maybeNull(types.string),
    lastName: types.string,
    mobileNumber: types.string,
    countryCode: types.string,
    userStatus: types.string,
    orderId: types.maybe(types.string),
  })
  .actions((self) => ({
    setOrderId(id: string | undefined) {
      self.orderId = id
    },
  }))

const LrnMappingObject = types.model('LrnMappingObject', {
  product: types.model({
    id: types.number,
    name: types.string,
  }),
  circleDetails: types.model({
    id: types.number,
    name: types.string,
  }),
})

const LrnMappingTempData = types.model('LrnMappingTempData', {
  mappingList: types.optional(types.array(LrnMappingObject), []),
})

const BillFetchTempData = types.model('BillFetchTempData', {})
const lrnMappingTempData = types.model('BillFetchTempData', {})

const BillPaymentAgentOnboard = types
  .model('CustomerDetails', {
    firstName: types.optional(types.string, ''),
    lastName: types.optional(types.string, ''),
    dob: types.optional(types.string, ''),
    mobile: types.optional(types.string, ''),
    street: types.optional(types.string, ''),
    doorNumber: types.optional(types.string, ''),
    pinCode: types.optional(types.string, ''),
    city: types.optional(types.string, ''),
    state: types.optional(types.string, ''),
    occupation: types.optional(types.string, ''),
    remittanceUserId: types.optional(types.string, ''),
    aadhaarToken: types.optional(types.string, ''),
    billerCategories: types.optional(types.array(types.frozen()), []),
    orderId: types.maybe(types.string),
  })
  .volatile(() => ({
    agentJFSUserId: '',
    authorizationCode: '',
    secureToken: null as any,
    tempCustomerData: null as typeof CustomerTempData.Type | null,
    fetchBillTempData: null as typeof BillFetchTempData.Type | null,
    tempLrnMappingData: null as typeof LrnMappingTempData.Type | null,
  }))
  .actions((self) => ({
    setAgentJFSUserId(id: string) {
      self.agentJFSUserId = id
    },
    setCustomerData(data: {
      jfsUserId: string
      firstName: string
      middleName: string | null | undefined
      lastName: string
      mobileNumber: string
      countryCode: string
      userStatus: string
    }) {
      const middleNameValue = data.middleName || null
      self.tempCustomerData = CustomerTempData.create({
        jfsUserId: data.jfsUserId,
        firstName: data.firstName,
        middleName: middleNameValue,
        lastName: data.lastName,
        mobileNumber: data.mobileNumber,
        countryCode: data.countryCode,
        userStatus: data.userStatus,
      })
    },
    setOrderId(id: string) {
      self.orderId = id
      if (self.tempCustomerData) {
        self.tempCustomerData.setOrderId(id)
      } else {
        console.log('tempCustomerData not initialized')
        console.warn('tempCustomerData not initialized')
      }
    },
    clearTempOrderId() {
      sessionStorage.setItem('pending_order_value', undefined)
      localStorage.setItem('pending_order_value', undefined)
      self.orderId = undefined
      if (self.tempCustomerData) {
        self.tempCustomerData.orderId = undefined
      }
    },
    clearCustomerData() {
      self.tempCustomerData = null
    },
    setLrnMappingData(data: typeof LrnMappingObject.Type[]) {
      self.tempLrnMappingData = LrnMappingTempData.create({
        mappingList: data,
      })
    },
    clearLrnMappingData() {
      self.tempLrnMappingData = null
    },
    checkWhetherAgentExists: flow(function* checkWhetherAgentExists(mobile) {
      try {
        const response = yield checkWhetherTheAgentExistsApi(RootStore.moneyTransferSession.getTokens, mobile)
        console.log('htag response', response)
        if (response?.code === CUSTOMER_VALIDATION_CODES?.DOES_NOT_EXIST) {
          RootStore.message.setMessage(
            DomesticMoneyTransferStrings.createNewUser ?? '',
            ToastType?.POSITIVE?.toUpperCase(),
          )
        }
        self.remittanceUserId = response?.remittanceUserId
        self.aadhaarToken = response?.aadharToken
        self.firstName = response?.firstName
        self.lastName = response?.lastName
        self.mobile = mobile
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    // createIntentAPIAction: flow(function* createIntentAPIAction(requestBody: any) {
    //   console.log('STORE: createIntentAPIAction initiated with payload:', requestBody)
    //   const environment = 'SIT'
    //   const HARDCODED_REDIRECT_URL = 'https://sit-apig.test.jiobank.in/'
    //   try {
    //     const response = yield createIntentAPI(RootStore.moneyTransferSession.getTokens, requestBody)
    //     console.log('STORE: createIntentAPIAction response:', response)
    //     const redirectionUrl = buildPaymentRedirectUrl(response, environment)

    //     if (!redirectionUrl) {
    //       // Throw an error if the URL could not be generated
    //       throw new Error('Failed to generate Payment Gateway redirection URL.')
    //     }
    //     const modifiedResponse = {
    //       ...response,
    //       redirectionUrl: redirectionUrl, // The dynamic, signed URL
    //     }
    //     console.log('modifiedResponse from store with redirectionUrl', modifiedResponse)
    //     return response
    //   } catch (err) {
    //     console.error('STORE: createIntentAPIAction error:', err)
    //     RootStore.message.handleError(err)
    //     throw err
    //   }
    // }),
    updatePaymentAPIActionBC: flow(function* updatePaymentAPIActionBC(requestBody: any) {
      console.log('STORE: updatePaymentAPIActionBC initiated with payload:', requestBody)
      try {
        const response = yield updatePaymentAPI(RootStore.moneyTransferSession.getTokens, requestBody)
        console.log('STORE: updatePaymentAPIActionBC response:', response)
        return response
      } catch (err) {
        console.error('STORE: updatePaymentAPIActionBC error:', err)
        RootStore.message.handleError(err)
        throw err
      }
    }),
    checkStatusAPIActionBC: flow(function* checkStatusAPIActionBC(requestBody: any) {
      console.log('STORE: checkStatusAPIActionBC initiated with payload:', requestBody)
      try {
        const response = yield checkStatusAPI(RootStore.moneyTransferSession.getTokens, requestBody)
        console.log('STORE: checkStatusAPIActionBC response:', response)
        return response
      } catch (err) {
        console.error('STORE: checkStatusAPIActionBC error:', err)
        if (err.type === 'NETWORK_ERROR') {
          console.warn('Network glitch during status check. Retrying naturally via polling...')
          throw err // Component will catch this and retry in 5s
        }

        RootStore.message.handleError(err)
        throw err
      }
    }),
    createOrderAPIActionBC: flow(function* createOrderAPIActionBC(requestBody: any) {
      console.log('STORE: createOrderAPIActionBC initiated with payload:', requestBody)
      try {
        const response = yield createOrderAPI(RootStore.moneyTransferSession.getTokens, requestBody)
        console.log('STORE: createOrderAPIActionBC response:', response)
        return response
      } catch (err) {
        console.error('STORE: createOrderAPIActionBC error:', err)
        RootStore.message.handleError(err)
        throw err
      }
    }),
    getOrderHistoryActionBC: flow(function* getOrderHistoryActionBC(requestBody: any) {
      console.log('STORE: getOrderHistoryActionBC initiated with payload:', requestBody) // Note: Corrected log message
      try {
        const response = yield getOrderHistoryBCApi(RootStore.moneyTransferSession.getTokens, requestBody)
        console.log('STORE: getOrderHistoryActionBC response:', response)
        return response
      } catch (err) {
        console.error('STORE: getOrderHistoryActionBC error:', err)
        RootStore.message.handleError(err)
        throw err
      }
    }),
    getBrowsePlanListActionBC: flow(function* getBrowsePlanListActionBC(requestBody: any) {
      console.log('STORE: getBrowsePlanListActionBC initiated with payload:', requestBody)
      try {
        const response = yield getBrowsePlanListBCApi(RootStore.moneyTransferSession.getTokens, requestBody)
        console.log('STORE: getBrowsePlanListActionBC response:', response)
        return response
      } catch (err) {
        console.error('STORE: getBrowsePlanListActionBC error:', err)
        RootStore.message.handleError(err)
        throw err
      }
    }),
    getCircleListActionBC: flow(function* getCircleListActionBC(requestBody: any) {
      console.log('STORE: getCircleListActionBC initiated with payload:', requestBody)
      try {
        // This correctly calls the updated network service function
        const response = yield getCircleListBCApi(RootStore.moneyTransferSession.getTokens, requestBody)
        console.log('STORE: getCircleListActionBC response:', response)
        return response
      } catch (err) {
        console.error('STORE: getCircleListActionBC error:', err)
        RootStore.message.handleError(err)
        throw err
      }
    }),
    getLRNMappingActionBC: flow(function* getLRNMappingActionBC(requestBody: any) {
      console.log('STORE: getLRNMappingActionBC initiated with payload:', requestBody)
      const localSelf = self as IBillPaymentAgentOnboard
      try {
        const response = yield getLRNMappingBCApi(RootStore.moneyTransferSession.getTokens, requestBody)
        console.log('STORE: getLRNMappingActionBC response:', response)
        if (Array.isArray(response)) {
          localSelf.setLrnMappingData(response)
        }
        return response
      } catch (err) {
        console.error('STORE: getLRNMappingActionBC error:', err)
        localSelf.clearLrnMappingData()
        RootStore.message.handleError(err)
        throw err
      }
    }),
    callGetAuthenticatorListBC: flow(function* callGetAuthenticatorListBC(productId: number) {
      console.log('STORE: callGetAuthenticatorListBC initiated for productId:', productId)
      try {
        const response = yield getAuthenticatorList(RootStore.moneyTransferSession.getTokens, {
          productId: productId,
        })
        console.log('STORE: getAuthenticatorListBCAction response:', response)
        return response
      } catch (err) {
        console.error('STORE: getAuthenticatorListBCAction error:', err)
        RootStore.message.handleError(err)
        throw err
      }
    }),
    BillFetchActionBC: flow(function* BillFetchActionBC(payload: any, jfsUserId: string) {
      console.log('STORE: BillFetchActionBC initiated with payload:', payload)
      try {
        const response = yield billFetchAPI(RootStore.moneyTransferSession.getTokens, payload, jfsUserId)
        console.log('STORE: BillFetchActionBC response:', response)
        return response
      } catch (err) {
        console.error('STORE: BillFetchActionBC error:', err)
        RootStore.message.handleError(err)
        throw err
      }
    }),
    fetchFavoriteTransactionsBC: flow(function* fetchFavoriteTransactionsBC(data: any) {
      try {
        const rawResponse = yield getFavoriteTransactionsBCApi(RootStore.moneyTransferSession.getTokens, data)
        if (Array.isArray(rawResponse)) {
          const transformedData = rawResponse
            .filter((item) => item?.order?.product?.id != null)
            .map((item) => ({
              billerMasterId: item.order.product.id,
              ...item,
            }))

          console.log('STORE: fetchFavoriteTransactionsBC transformed data:', transformedData)
          return transformedData
        }

        console.log('STORE: fetchFavoriteTransactionsBC raw response (non-array):', rawResponse)
        return rawResponse
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    // fetchFavoriteTransactionsBC: flow(function* fetchFavoriteTransactionsBC(data: any) {
    //   try {
    //     const response = yield getFavoriteTransactionsBCApi(RootStore.moneyTransferSession.getTokens, data)
    //     console.log('STORE: fetchFavoriteTransactionsBC response:', response)
    //     console.log('STORE: fetchFavoriteTransactionsBC data:', data)
    //     return response
    //   } catch (err) {
    //     RootStore.message.handleError(err)
    //     throw err
    //   }
    // }),
    manageFavTxnsActionBC: flow(function* manageFavTxnsActionBC(data: any) {
      try {
        const response = yield manageFavTxnsApi(RootStore.moneyTransferSession.getTokens, data)
        console.log('STORE: manageFavTxnsActionBC response:', response)
        console.log('STORE: manageFavTxnsActionBC data:', data)
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        console.log('Error at STORE: manageFavTxnsActionBC data:', data)
        throw err
      }
    }),
    agentOnboarding: flow(function* agentOnboarding(data: any) {
      try {
        const response = yield agentOnboardingApi(RootStore.moneyTransferSession.getTokens, data)
        console.log('agentOnboarding in Model store', response)
        self.remittanceUserId = response?.data?.remittanceUserId
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    agentOnboardingV3: flow(function* agentOnboardingV3(data: any) {
      try {
        const response = yield agentOnboardingApiV3(RootStore.moneyTransferSession.getTokens, data)
        // self.remittanceUserId = response?.data?.remittanceUserId
        console.log('Store response agentOnboardingV3', response)
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    getProductListBC: flow(function* getProductListBC() {
      try {
        const response = yield getCategoryListV2Api(RootStore.agent.session)
        if (response && Array.isArray(response)) {
          const orderMap = new Map()
          CATEGORY_ORDER.forEach((type, index) => {
            orderMap.set(type, index)
          })
          const UNKNOWN_PRIORITY = 999
          const sortedResponse = response.sort((a: any, b: any) => {
            const typeA = a.categoryGroup.categoryType
            const typeB = b.categoryGroup.categoryType
            const priorityA = orderMap.get(typeA) ?? UNKNOWN_PRIORITY
            const priorityB = orderMap.get(typeB) ?? UNKNOWN_PRIORITY

            return priorityA - priorityB
          })
          self.billerCategories.replace(sortedResponse.map((item) => item.categoryGroup))
        }
        console.log(response, 'Avinash Category Response')
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    callGetProductListBC: flow(function* callGetProductListBC(categoryId: number) {
      try {
        const response = yield getProductListBCApi(RootStore.moneyTransferSession.getTokens, {
          categoryId: categoryId,
        })
        console.log('STORE: getProductListBCApi response (before return):', response)
        console.log('STORE: getProductListBCApi response (before return):', response)

        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    fetchUserActionBC: flow(function* fetchUserActionBC(data: { mobileNumber: string }) {
      const localSelf = self as IBillPaymentAgentOnboard // Cast self to the full type
      // 1. Check if App is authenticated first
      if (!RootStore.moneyTransferSession.appAccessToken) {
        yield RootStore.moneyTransferSession.appAuthenticateApi()
      }
      try {
        if (!RootStore.bcAppInfo.userAccessToken || !RootStore.bcAppInfo.userIdentifier) {
          throw new Error('Pre-flight check failed: User access tokens are missing/uninitialized.')
        }

        const response = yield fetchUserBC(RootStore.moneyTransferSession.getTokens, data)
        console.log('Debug Store: fetchUserActionBC response', response)
        localSelf.setCustomerData({
          jfsUserId: response?.jfsUserId || '',
          firstName: response?.user?.name?.firstName || '',
          middleName: response?.user?.name?.middleName || null,
          lastName: response?.user?.name?.lastName || '',
          mobileNumber: data.mobileNumber,
          countryCode: '+91',
          userStatus: response?.user?.status || 'Active',
        })

        return response
      } catch (err) {
        console.log('Store: fetchUserActionBC Error', err)
        console.log('Store DEBUG: Error Object before crash', JSON.stringify(err))
        RootStore.message.handleError(err)
        throw err
      }
    }),
    genereteOtpBCApiActionBC: flow(function* genereteOtpBCApiActionBC(data: { mobileNumber: string }) {
      try {
        const response = yield genereteOtpBCApi(RootStore.moneyTransferSession.getTokens, data)
        self.secureToken = response?.secure || null
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    registerUserActionBC: flow(function* registerUserActionBC(data: {
      mobileNumber: string
      firstName: string
      middleName?: string
      lastName: string
    }) {
      try {
        if (!self.authorizationCode) {
          console.error('REGISTRATION ERROR: Authorization Code is missing.')
          throw new Error('Authorization Code is missing. Please verify OTP first.')
        }

        const body = {
          ...data,
          authorizationCode: self.authorizationCode,
        }
        const response = yield registerUserBCApi(RootStore.moneyTransferSession.getTokens, body)
        const newJfsUserId = response?.jfsUserId || ''

        if (self.tempCustomerData) {
          ;(self as IBillPaymentAgentOnboard).setCustomerData({
            jfsUserId: newJfsUserId,
            firstName: self.tempCustomerData.firstName,
            middleName: self.tempCustomerData.middleName,
            lastName: self.tempCustomerData.lastName,
            mobileNumber: self.tempCustomerData.mobileNumber,
            countryCode: self.tempCustomerData.countryCode,
            userStatus: self.tempCustomerData.userStatus,
          })
        } else {
          ;(self as IBillPaymentAgentOnboard).setCustomerData({
            jfsUserId: newJfsUserId,
            firstName: data.firstName,
            middleName: data.middleName || null,
            lastName: data.lastName,
            mobileNumber: data.mobileNumber,
            countryCode: '+91',
            userStatus: 'Active',
          })
        }
        self.authorizationCode = ''
        return response
      } catch (err) {
        console.error('STORE CATCH: Registration failed.', err)
        RootStore.message.handleError(err)
        throw err
      }
    }),
    verifyOtpActionBC: flow(function* verifyOtpActionBC(data: { mobileNumber: string; otp: string; secure?: any }) {
      if (self.tempCustomerData) {
        ;(self as IBillPaymentAgentOnboard).clearCustomerData()
      }
      self.authorizationCode = ''

      try {
        const randomEncryptionKey = generateRandomString(32)
        const encryptedOtp = AESEncrypt(randomEncryptionKey, data.otp)
        const encryptedSymmetricKey = RSAEncrypt(randomEncryptionKey)
        if (!encryptedSymmetricKey) {
          throw new Error('Failed to encrypt security key (RSA encryption failed).')
        }
        const response = yield VerifyOtpBCApi(RootStore.moneyTransferSession.getTokens, {
          mobileNumber: data.mobileNumber,
          encryptedOtp: encryptedOtp,
          encryptedSymmetricKey: encryptedSymmetricKey,
        })
        if (response.status === 'SUCCESS' && response.jfsUserId) {
          if (self.tempCustomerData) {
            ;(self as IBillPaymentAgentOnboard).setCustomerData({
              jfsUserId: response.jfsUserId,
              firstName: self.tempCustomerData.firstName,
              middleName: self.tempCustomerData.middleName,
              lastName: self.tempCustomerData.lastName,
              mobileNumber: data.mobileNumber,
              countryCode: self.tempCustomerData.countryCode,
              userStatus: self.tempCustomerData.userStatus,
            })
          }
          self.authorizationCode = response.authorizationCode || ''
          return response
        } else if (response.status === 'FAILURE' && response.error?.code === '33872' && response.authorizationCode) {
          self.authorizationCode = response.authorizationCode
          return response
        }
        RootStore.message.handleError(response)
        throw {
          code: response.error?.code || 'OTP_VERIFY_FAILURE',
          message: response.error?.message || 'Invalid OTP or unhandled server response.',
        }
      } catch (err: any) {
        console.error('STORE CATCH: Verification failed.', err)
        if (self.tempCustomerData) {
          ;(self as IBillPaymentAgentOnboard).clearCustomerData()
        }
        self.authorizationCode = ''
        throw err
      }
    }),
  }))
  .views((self) => ({}))

const BillPaymentAgentOnboardData = BillPaymentAgentOnboard.create({
  billerCategories: [],
})
export interface IBillPaymentAgentOnboard extends Instance<typeof BillPaymentAgentOnboard> {}

export { BillPaymentAgentOnboard, BillPaymentAgentOnboardData }
